const IMAGES = {
    logoQ: require('../images/homePage/logo.png').default,
    logoSound: require('../images/homePage/musicPlayer.png').default,
    omotolaPort: require('../images/homePage/omotola_portrait.webp').default,
    downArrow: require('../images/homePage/down_arrow.png').default,
    githubIcon: require('../images/homePage/github_logo.png').default,
    twitter: require('../images/homePage/twitter_logo.png').default,
    instagram: require('../images/homePage/instagram_logo.png').default,
    linkedIn: require('../images/homePage/linkedin_logo.png').default,
    
    contactImg: require('../images/contactPage/contact_img.webp').default,
    swipeArrow: require('../images/webAppPage/swipe_arrow.png').default,

    nike: require('../images/webAppPage/nike_ecomm.webp').default,
    netflix: require('../images/webAppPage/netflix.webp').default,
    chatApp: require('../images/webAppPage/chat_app.webp').default,
    facebook: require('../images/webAppPage/facebook.webp').default,
    linkedIn_clone: require('../images/webAppPage/linkedin.webp').default,
    adminDash: require('../images/webAppPage/adminDash.webp').default,
    cryptoApp: require('../images/webAppPage/Crypto_tracker.webp').default,
    teslaImg: require('../images/webAppPage/tesla_clone.webp').default,
    mario: require('../images/webAppPage/mario.webp').default,
    alan: require('../images/webAppPage/alan.webp').default,
    covid: require('../images/webAppPage/covid.webp').default,
    blog: require('../images/webAppPage/blog.webp').default,
    zoom: require('../images/webAppPage/zoom.webp').default,
    quiz: require('../images/webAppPage/quiz.webp').default,
    airBnb: require('../images/webAppPage/airbnb.webp').default,
    cryptoPrice: require('../images/webAppPage/crypto_search.webp').default,



    archi_slide1: require('../images/architecture/archi_slider_1.webp').default,
    archi_slide2: require('../images/architecture/archi_slider_2.webp').default,
    archi_slide3: require('../images/architecture/archi_slider_3.webp').default,
    archi_slide4: require('../images/architecture/archi_slider_4.webp').default,
    archi_slide5: require('../images/architecture/archi_slider_5.webp').default,
    archi_slide6: require('../images/architecture/archi_slider_6.webp').default,
    archi_slide7: require('../images/architecture/archi_slider_7.webp').default,
    archi_slide8: require('../images/architecture/archi_slider_8.webp').default,
    archi_slide9: require('../images/architecture/archi_slider_9.webp').default,
    archi_slide10: require('../images/architecture/archi_slider_10.webp').default,
    archi_slide11: require('../images/architecture/archi_slider_11.webp').default,
    
    search_icon: require('../images/architecture/search_icon.png').default,
    archi_card1: require('../images/architecture/archi_card1.webp').default,
    archi_card2: require('../images/architecture/archi_card2.webp').default,
    archi_card3: require('../images/architecture/archi_card3.webp').default,
    archi_card4: require('../images/architecture/archi_card4.webp').default,
    archi_card5: require('../images/architecture/archi_card5.webp').default,
    archi_view1: require('../images/architecture/archi_view1.webp').default,
    archi_view2: require('../images/architecture/archi_view2.webp').default,
    archi_view3: require('../images/architecture/archi_view3.webp').default,
    archi_view4: require('../images/architecture/archi_view4.webp').default,
    archi_view5: require('../images/architecture/archi_view5.webp').default,

    archi_view1_a: require('../images/architecture/archi_view1_a.webp').default,
    archi_view1_b: require('../images/architecture/archi_view1_b.webp').default,
    archi_view1_c: require('../images/architecture/archi_view1_c.webp').default,
    archi_view1_d: require('../images/architecture/archi_view1_d.webp').default,
    archi_view2_a: require('../images/architecture/archi_view2_a.webp').default,
    archi_view2_b: require('../images/architecture/archi_view2_b.webp').default,
    archi_view2_c: require('../images/architecture/archi_view2_c.webp').default,
    archi_view2_d: require('../images/architecture/archi_view2_d.webp').default,
    archi_view2_e: require('../images/architecture/archi_view2_e.webp').default,
    archi_view2_f: require('../images/architecture/archi_view2_f.webp').default,
    archi_view3_a: require('../images/architecture/archi_view3_a.webp').default,
    archi_view3_b: require('../images/architecture/archi_view3_b.webp').default,
    archi_view3_c: require('../images/architecture/archi_view3_c.webp').default,
    archi_view3_d: require('../images/architecture/archi_view3_d.webp').default,
    archi_view3_e: require('../images/architecture/archi_view3_e.webp').default,
    archi_view3_f: require('../images/architecture/archi_view3_f.webp').default,
    archi_view3_g: require('../images/architecture/archi_view3_g.webp').default,
    archi_view4_a: require('../images/architecture/archi_view4_a.webp').default,
    archi_view4_b: require('../images/architecture/archi_view4_b.webp').default,
    archi_view4_c: require('../images/architecture/archi_view4_c.webp').default,
    archi_view5_a: require('../images/architecture/archi_view5_a.webp').default,
    archi_view5_b: require('../images/architecture/archi_view5_b.webp').default,
    archi_view5_c: require('../images/architecture/archi_view5_c.webp').default,
    archi_view5_d: require('../images/architecture/archi_view5_d.webp').default,

    omotola_pp: require('../images/about/omotola_profPic.webp').default,
    icon_react: require('../images/about/icon_react.png').default,
    icon_html: require('../images/about/icon_html.png').default,
    icon_css: require('../images/about/icon_css.png').default,
    icon_git: require('../images/about/icon_git.png').default,
    icon_js: require('../images/about/icon_js.png').default,
    icon_python: require('../images/about/icon_python.png').default,
    icon_firebase: require('../images/about/icon_firebase.png').default,
    icon_linux: require('../images/about/icon_linux.png').default,
    icon_node: require('../images/about/icon_node.png').default,
    icon_mongoDB: require('../images/about/icon_mongoDB.png').default,
    icon_SQL: require('../images/about/icon_SQL.png').default,
    icon_express: require('../images/about/icon_express.png').default,
    google_pod: require('../images/about/google.webp').default,
    wired_pod: require('../images/about/wiredpodcast.webp').default,
    ted_pod: require('../images/about/ted.webp').default,
    econs_pod: require('../images/about/economist.webp').default,

///
    cert_cad: require('../images/about/cert_cad.png').default,
    cert_git: require('../images/about/cert_git.png').default, 
    cert_JS: require('../images/about/cert_JSweb.png').default, 
    cert_cmd: require('../images/about/cert_cmd.png').default, 
    cert_web: require('../images/about/cert_web.jpg').default, 


    icon_cad: require('../images/about/icon_cad.png').default,
    icon_rhino: require('../images/about/icon_rhino.png').default,
    icon_lumion: require('../images/about/icon_lumion.png').default,
    icon_corona: require('../images/about/icon_corona.png').default,
    icon_revit: require('../images/about/icon_revit.png').default,
    icon_indesign: require('../images/about/icon_indesign.png').default,
    icon_illustr: require('../images/about/icon_illustr.png').default,
    icon_vray: require('../images/about/icon_vray.png').default,
    icon_max: require('../images/about/icon_max.png').default,
    icon_sketchup: require('../images/about/icon_sketchup.png').default,
    icon_ps: require('../images/about/icon_ps.png').default,
    icon_figma: require('../images/about/icon_figma.png').default,

    twitter_label: require('../images/about/twitter_label.png').default,
    spotify_label: require('../images/about/spotify_label.png').default,
    github_label: require('../images/about/github_label.png').default,
    spotify_song: require('../images/about/spotify_song.png').default,
};

export default IMAGES;